import React, { useMemo } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import GoogleCloudRegistryCredentialsForm from './GoogleCloudRegistryCredentialsForm'
import GoogleCloudRegistryMappingForm from './GoogleCloudRegistryMappingForm'
import { columnRenderArrayData } from 'utils/tableUtils'

function GoogleCloudRegistryConfigListing(props) {
    const formatDelimitedValues = (value) => value?.split(';').join(',')

    const extraColumns = useMemo(() => [
        {
        title: "Region",
        dataIndex: "region",
        width: 100
    }, {
        title: "Repos",
        dataIndex: "repos",
        render: (repos) => columnRenderArrayData(formatDelimitedValues(repos)),
        width: 100,
    }, {
        title: "Image",
        dataIndex: "image_id",
        render: (imageId) => columnRenderArrayData(formatDelimitedValues(imageId)),
        width: 100,
    }], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={GoogleCloudRegistryMappingForm}
            CredentialsForm={GoogleCloudRegistryCredentialsForm}
            extraColumns={extraColumns}
        />
    )
}

export default GoogleCloudRegistryConfigListing
